import React from "react";
import { IoLocationOutline} from "react-icons/io5";
import LocationIcon from "../../assets/location-icon.png"
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";


class LocationSearchInput extends React.Component<
  { locationDetail: any; value: any; disabled?: any },
  { address: string; disabled?: any }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      disabled: props.disabled,
      address: props.value
    };
  }
  handleChange = (address: any) => {
    this.setState({ address });
  };

  componentDidMount() {
    if (this.state.address) {
      this.handleSelect(this.state.address);
    }
  }

  handleSelect = (address: any) => {
    let locationDetail: any = {};
    geocodeByAddress(address).then(
      (response) => {
        response.map((value: any) => {
          locationDetail.formatted_address = value.formatted_address;
          locationDetail.lat = value.geometry.location.lat();
          locationDetail.lng = value.geometry.location.lng();
          value.address_components.map((location: any) => {
            if (location.types.includes("postal_code"))
              locationDetail.postalcode = location.long_name;
            if (location.types.includes("country"))
              locationDetail.country = location.long_name;
            if (location.types.includes("administrative_area_level_1"))
              locationDetail.state = location.long_name;
            if (location.types.includes("locality"))
              locationDetail.city = location.long_name;
          });
        });
        this.props.locationDetail(locationDetail);
        this.setState({ address: locationDetail.formatted_address });
      },
      (error) => {
        console.error(error);
      }
    );
  };
  render() {
    const { address } = this.state;
    return (
      <PlacesAutocomplete
        value={address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        highlightFirstSuggestion={true}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <div className="flex items-center bg-gray-200 rounded-full p-1">
              <img src={LocationIcon} alt="" className=" w-9 h-9 \" />
              <input
                {...getInputProps({
                  placeholder: "Search for your location",
                  className: "placeholder:text-[#E23744] bg-gray-200 w-full outline-none"
                })}
                disabled={this.state.disabled}
              />
            </div>

            <div className="autocomplete-dropdown-container lg:w-[90%] md:w-[70%] w-[70%] ">
              {loading && <div className="mt-2">Loading...</div>}
              {suggestions.map((suggestion, index) => {
                const className = suggestion.active
                  ? "suggestion-item--active rounded-lg"
                  : "suggestion-item rounded-lg";
                const style = suggestion.active
                  ? { backgroundColor: "#fafafa", cursor: "pointer" }
                  : { backgroundColor: "#ffffff", cursor: "pointer" };
                  
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style
                    })}
                    key={index + "1"}
                    className="p-2"
                  >
                    <span className="mb-[2px] flex items-center gap-2"><IoLocationOutline/>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}
export default LocationSearchInput;
